import React from 'react';
import '../TestimonialsSection.css';

const AuditedTestimonialsSection: React.FC = () => {
  const testimonials = [
    {
      name: "Anna K.",
      role: "Uczennica klasy 3 liceum",
      course: "Pakiet Premium - Przygotowanie do matury",
      rating: 5,
      text: "Dzieki kursom w Sigma Study zdalam mature rozszerzona z matematyki na 98%! Nauczyciele sa fantastyczni, wszystko tlumacza w sposob zrozumialy. Polecam kazdemu, kto chce naprawde zrozumiec matematyke.",
      avatarLetter: "A",
      avatarColor: "#e91e63",
      result: "Matura rozszerzona: 98%"
    },
    {
      name: "Piotr N.",
      role: "Rodzic ucznia klasy 8",
      course: "Pakiet Podstawowy - Matematyka gimnazjalna",
      rating: 5,
      text: "Moj syn Kacper mial ogromne problemy z matematyka. Po trzech miesiacach nauki w Sigma Study jego oceny poprawily sie z 2 na 4+. Nauczyciele maja niesamowite podejscie do dzieci!",
      avatarLetter: "P",
      avatarColor: "#2196f3",
      result: "Poprawa ocen z 2 na 4+"
    },
    {
      name: "Maria Z.",
      role: "Studentka matematyki",
      course: "Pakiet VIP - Matematyka wyzsza",
      rating: 5,
      text: "Indywidualne lekcje z Kornelem to byla najlepsza inwestycja w moja edukacje. Analiza matematyczna przestala byc koszmarem, a stala sie moim ulubionym przedmiotem. Serdecznie polecam!",
      avatarLetter: "M",
      avatarColor: "#4caf50",
      result: "Srednia ocen: 4.8/5.0"
    },
    {
      name: "Janusz K.",
      role: "Dorosly uczestnik kursu",
      course: "Matematyka dla doroslych",
      rating: 5,
      text: "Mialem przerwe w studiach i nie bylem w stanie poradzic sobie z matematyka numeryczna na 4tym roku. Dzieki Lukaszowi nadobilem braki, ktore mialem jeszcze z poprzednich poziomow nauczania i na koniec mialem 4!",
      avatarLetter: "J",
      avatarColor: "#ff9800",
      result: "Ukonczenie kursu z wyroznnieniem"
    },
    {
      name: "Ola W.",
      role: "Uczennica klasy 6",
      course: "Szkola podstawowa",
      rating: 5,
      text: "Matematyka wczesniej byla dla mnie bardzo trudna, ale dzieki Lukaszowi z Sigma Study teraz to moj ulubiony przedmiot! Lekcje sa ciekawe i pelne zaangazowania.",
      avatarLetter: "O",
      avatarColor: "#9c27b0",
      result: "Ocena wzrosla z 3 na 5"
    },
    {
      name: "Janek A.",
      role: "Uczen przygotowujacy sie do olimpiady",
      course: "Przygotowanie do konkursow",
      rating: 5,
      text: "Kornel przygotowal mnie do Olimpiady Matematycznej Juniorow. Dzieki jego wsparciu zostalem laureatem 2 stopnia! W liceum przugotowuje sie do Olimpiady Matematycznej.",
      avatarLetter: "R",
      avatarColor: "#f44336",
      result: "Laureat Olimpiady Matematycznej Juniorow"
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={`star ${index < rating ? 'filled' : ''}`}>
        *
      </span>
    ));
  };

  return (
    <section id="testimonials" className="testimonials-section">
      <div className="testimonials-container">
        <div className="section-header">
          <h2>Co Mowia Nasi Uczniowie</h2>
          <p>Przeczytaj opinie osob, ktore juz osiagnely sukces dzieki naszym kursom</p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-header">
                <div
                  className="testimonial-avatar google-avatar"
                  style={{ backgroundColor: testimonial.avatarColor }}
                >
                  <span className="avatar-letter">{testimonial.avatarLetter}</span>
                </div>
                <div className="testimonial-info">
                  <h4 className="testimonial-name">{testimonial.name}</h4>
                  <p className="testimonial-role">{testimonial.role}</p>
                  <p className="testimonial-course">{testimonial.course}</p>
                </div>
              </div>

              <div className="testimonial-rating">
                {renderStars(testimonial.rating)}
              </div>

              <blockquote className="testimonial-text">
                "{testimonial.text}"
              </blockquote>

              <div className="testimonial-result">
                <strong>Rezultat: {testimonial.result}</strong>
              </div>
            </div>
          ))}
        </div>

        <div className="testimonials-summary">
          <div className="summary-stats">
            <div className="summary-stat">
              <div className="stat-number">4.9/5</div>
              <div className="stat-label">Srednia ocena</div>
            </div>
            <div className="summary-stat">
              <div className="stat-number">500+</div>
              <div className="stat-label">Pozytywnych opinii</div>
            </div>
            <div className="summary-stat">
              <div className="stat-number">95%</div>
              <div className="stat-label">Poleca znajomym</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuditedTestimonialsSection;
